import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import StandardLayout from '../layouts/StandardLayout';
import * as identity from '../../utilities/identity';
import { Roles } from '../../utilities/Enums';

interface State {}

interface Props extends RouteComponentProps<{}> {}

class NotFoundPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const role = identity.getMyRole();
        const isLoggedIn =
            role === Roles.SystemAdmin ||
            role === Roles.CompanyAdmin ||
            role === Roles.PropertyAdmin ||
            role === Roles.PropertyUser;

        return (
            <StandardLayout isRegisteredUserFacing={isLoggedIn}>
                <div className="content container">
                    <h1>Page not found</h1>
                </div>
            </StandardLayout>
        );
    }
}

export default withRouter<Props>(NotFoundPage);



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.tsx